import { cloneDeep } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Table } from "semantic-ui-react";

import { MediaAs } from "../../styles/Media.js";

import ActionDropdownMenu from "../actionDropdownMenu/ActionDropdownMenu.jsx";
import withConfirmationModal from "../modals/withConfirmationModal.js";
import LinkWithReset from "../utils/LinkWithReset.jsx";

import { OPERATIONS } from "../../constants/operations.js";

import { operationActionByType } from "../../state/reducers/operations/operationActions.js";
import { getEntityUsers } from "../../state/reducers/entity/entityActions.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class EntityUserList extends PureComponent {
  static propTypes = {
    entity: PropTypes.object,
    users: PropTypes.array,
    location: PropTypes.object,
    disabled: PropTypes.bool.isRequired,

    openModal: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,

    operationActionByType: PropTypes.func.isRequired,
    showGroup: PropTypes.bool.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    showGroup: false,
    copyKey: "users.user_panel"
  };

  constructor(props) {
    super(props);

    this.state = {
      activeUser: undefined
    };
  }

  // -- HANDLERS -- //

  handleDelete = activeUser => {
    const { users, openModal, copyKey } = this.props;

    const user = cloneDeep(users.find(item => item["@id"] === activeUser));
    user.name = user.group.name;

    this.setState({ activeUser: activeUser }, () => {
      openModal(
        this.doDelete,
        `${copyKey}.modals.delete_modal`,
        undefined,
        user
      );
    });
  };

  doDelete = () => {
    const { entity, users, location, operationActionByType } = this.props;
    const { activeUser } = this.state;

    const user = users.find(item => item["@id"] === activeUser);

    const successAction = getEntityUsers(entity["@id"], location.search);

    operationActionByType(user["@type"], user, OPERATIONS.DELETE, undefined, {
      success: successAction
    });
  };

  // -- RENDER -- //

  getViewPath = item => {
    const { entity } = this.props;

    let viewPath = `${entity["@id"]}${item["@id"]}`;

    return viewPath;
  };

  renderUserRows = () => {
    const { users, showGroup, copy } = this.props;

    return users.map(item => {
      const viewPath = this.getViewPath(item);

      return (
        <Table.Row key={item["@id"]}>
          <Table.Cell>
            <LinkWithReset to={viewPath} className="table-link">
              {item.email}
            </LinkWithReset>
          </Table.Cell>
          {showGroup && (
            <MediaAs greaterThan="smallTablet" as={Table.Cell} collapsing>
              {item.group.name}
            </MediaAs>
          )}
          <Table.Cell collapsing>
            <ActionDropdownMenu
              data={item}
              viewPath={viewPath}
              onDelete={this.handleDelete}
              copy={copy("basic_resource_actions")}
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  };

  render() {
    const { users, showGroup, copyKey, copy } = this.props;

    // bail early if base permissions are not met
    if (!users) return null;

    if (users.length < 1) {
      return <p>{copy(`${copyKey}.no_users`)}</p>;
    }

    return (
      <Table disabled celled basic striped unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{copy(`${copyKey}.email`)}</Table.HeaderCell>
            {showGroup && (
              <MediaAs
                greaterThan="smallTablet"
                as={Table.HeaderCell}
                collapsing
              >
                {copy(`${copyKey}.group_label`)}
              </MediaAs>
            )}
            <Table.HeaderCell collapsing />
          </Table.Row>
        </Table.Header>
        <Table.Body>{this.renderUserRows()}</Table.Body>
      </Table>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  operationActionByType: (...args) => dispatch(operationActionByType(...args))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withConfirmationModal(EntityUserList));
